import { Box, Flex, Text, Image, Divider, Grid, Table, Thead, Tr, Th, Tbody, Td, Button, Input, Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, useDisclosure, Tooltip, } from '@chakra-ui/react';
import MyDiv from './newProofTaxRegime.style';
import CheckMarkIcon from '../../../../assets/images/CheckMarkIcon.svg';
import SalaryIcon from "../../../../assets/images/SalaryIcon.svg";
import { AlertCard, CustomButton } from '../../../../components';
import DummyPdf from "../../../../assets/documents/pdf-test.pdf";
import DummyPdf2 from "../../../../assets/documents/Monthly-Employee-Attendance-Sheet.pdf"
import { useState } from 'react';


const NewProofTaxRegime = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertStatus, setAlertStatus] = useState<'Accept' | 'Reject' | null>(null);
    const [pendingPoiIndex, setPendingPoiIndex] = useState<number | null>(null);

    const [selectedPoiIndex, setSelectedPoiIndex] = useState<number | null>(null);
    const [poiDetails, setPoiDetails] = useState<any[]>([
        { section: '80CCD(2)', declared: '₹ 12345', proofSubmitted: '₹ 12345', document: DummyPdf },
        { section: 'Section 80JJAA', declared: '₹ 12345', proofSubmitted: '₹ 12345', document: DummyPdf2 },
        { section: 'Section 80CCH', declared: '₹ 12345', proofSubmitted: '₹ 12345', document: DummyPdf },
    ]);

    const selectedPoi = selectedPoiIndex !== null ? poiDetails[selectedPoiIndex] : null;

    const sections = [
        {
            title: 'Tax Summary',
            icon: SalaryIcon,
            data: [
                { label: 'Gross Annual Salary', value: '₹ 12345' },
                { label: 'Net Annual Salary', value: '₹ 12345' },
                { label: 'Total Tax Deductions', value: '₹ 12345', isHeading: true },
                { label: 'Declared Amount', value: '₹ 12345' },
                { label: 'Proof Submitted', value: '₹ 12345' },
                { label: 'Net Salary', value: '₹ 12345', isHeading: true },
            ],
        },
    ];

    const openAlert = (index: number, status: 'Accept' | 'Reject') => {
        setPendingPoiIndex(index);
        setAlertStatus(status);
        setAlertOpen(true);
    };

    const onConfirmStatusChange = () => {
        if (pendingPoiIndex !== null && alertStatus) {
            const updatedPoiDetails = [...poiDetails];
            updatedPoiDetails[pendingPoiIndex].status = alertStatus === 'Accept' ? 'accepted' : 'rejected';
            updatedPoiDetails[pendingPoiIndex].handledBy = 'HR Name';
            setPoiDetails(updatedPoiDetails);
        }
        setAlertOpen(false);
        onClose(); // close drawer if open
    };

    const handleViewClick = (poi: any, index: any) => {
        setSelectedPoiIndex(index);
        onOpen();
    };

    const handleVerifiedAmountChange = (index: number, value: string) => {
        const updatedPoiDetails = [...poiDetails];
        updatedPoiDetails[index].verifiedAmt = value;
        setPoiDetails(updatedPoiDetails);
    };
    const formatCurrency = (value: string | undefined) => {
        if (!value) return '';
        return `₹ ${value}`;
    };

    return (
        <MyDiv>
            <Flex gap={2} mb={4} mt={4}>
                <Box className='declaration'>
                    <Image src={CheckMarkIcon} />
                    <Text className="font-poppins text_sm text_medium">POI Submitted</Text>
                </Box>
                <Box>
                    <Box className='regime'>
                        <Flex gap={4} alignItems={'center'}>
                            <Text color={'#800080'} className="font-poppins text_sm text_medium">Tax Regime</Text>
                            <Text className='new font-poppins text_sm text_medium' >New Tax Regime</Text>
                        </Flex>
                    </Box>
                </Box>
            </Flex>
            {sections.map((section, index) => (
                <Box key={index} pt={2} mb={6} className="main">
                    <Flex justify="space-between" align="center" mb={2} pl={5} pr={5}>
                        <Flex align="center" gap={3}>
                            <Image src={section.icon} alt={section.title} />
                            <Text className="font-poppins text_sm text_medium col">{section.title}</Text>
                        </Flex>
                    </Flex>
                    {section.data.map((item, i) => (item.isHeading ? (
                        <Box key={i} py={2} px={10}>
                            <Grid templateColumns="1fr 1fr" alignItems="center">
                                <Text className="font-poppins text_sm text_medium" color="rgba(102, 102, 102, 1)" mb={3}>{item.label}</Text>
                                {item.value && (
                                    <Text className="font-poppins text_sm text_medium col" ml={8}>{item.value}</Text>
                                )}
                            </Grid>
                        </Box>) : (
                        <Box key={i} py={2} px={10} bg="#FFFFFF" borderRadius={8}>
                            <Grid templateColumns="1fr 1fr" alignItems="center">
                                <Text className="font-poppins text_sm text_medium" color="rgba(102, 102, 102, 1)" mb={3}>{item.label}</Text>
                                <Text className="font-poppins text_sm text_medium col" ml={8}>{item.value}</Text>
                            </Grid>
                            {!section.data[i + 1]?.isHeading && i !== section.data.length - 1 && <Divider mt={2} />}
                        </Box>
                    )))}
                </Box>
            ))}

            <Text className='font-poppins text_xl text_semibold'>POI Details</Text>
            <Box className="section-card">
                <Table variant='striped' colorScheme='gray'>
                    <Thead>
                        <Tr>
                            <Th className="font-poppins text_sm text_medium">Section</Th>
                            <Th className="font-poppins text_sm text_medium">Declared</Th>
                            <Th className="font-poppins text_sm text_medium">Proof Submitted</Th>
                            <Th className="font-poppins text_sm text_medium">Verified Amt</Th>
                            <Th className="font-poppins text_sm text_medium">Proof Document</Th>
                            <Th className="font-poppins text_sm text_medium">Action</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {poiDetails.map((poi, index) => (
                            <Tr key={index}>
                                <Td className="font-poppins text_sm text_medium">{poi.section}</Td>
                                <Td className="font-poppins text_sm text_medium">{poi.declared}</Td>
                                <Td className="font-poppins text_sm text_medium">{poi.proofSubmitted}</Td>
                                <Td className="font-poppins text_sm text_medium">
                                    {poi.status ? (
                                        formatCurrency(poi.verifiedAmt)
                                    ) : (
                                        <Input
                                            size='sm'
                                            type="text"
                                            placeholder='₹'
                                            value={poi.verifiedAmt ? `₹ ${poi.verifiedAmt}` : ''}
                                            onChange={(e) => {
                                                const rawValue = e.target.value.replace(/[^0-9]/g, '');
                                                handleVerifiedAmountChange(index, rawValue);
                                            }}
                                            isDisabled={poi.status !== undefined}
                                        />
                                    )}
                                </Td>
                                <Td>
                                    <Button
                                        variant="link"
                                        className="font-poppins text_sm text_medium"
                                        color="#006838"
                                        onClick={() => handleViewClick(poi, index)}
                                    >
                                        View
                                    </Button>
                                </Td>
                                <Td>
                                    {poi.status ? (
                                        <Text color={poi.status === 'accepted' ? '#00B103' : '#FF0000'} className="font-poppins text_sm text_regular" maxWidth="11vw" isTruncated>
                                            <Tooltip
                                                label={poi.status === 'accepted' ? 'Accepted by HR Name' : 'Rejected by HR Name'}
                                                aria-label="Full reason"
                                                bg="gray.700"
                                                color="white"
                                                placement="bottom-start"
                                                maxW="300px"
                                                hasArrow >
                                                <Box as="span" display="inline-block" w="100%" isTruncated>{poi.status === 'accepted' ? 'Accepted by HR Name' : 'Rejected by HR Name'}</Box>
                                            </Tooltip>

                                        </Text>
                                    ) : (
                                        <Flex gap={2}>
                                            <CustomButton className='reject font-poppins text_sm text_medium' title="Reject" onClick={() => openAlert(index, 'Reject')} />
                                            <CustomButton className='accept font-poppins text_sm text_medium' title="Accept" onClick={() => openAlert(index, 'Accept')} />
                                        </Flex>
                                    )}
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </Box>

            <Drawer isOpen={isOpen} placement='right' onClose={onClose} size="sm">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>{selectedPoi?.section}</DrawerHeader>
                    <Divider />
                    <DrawerBody>
                        {selectedPoi?.document ? (
                            <>

                                <iframe
                                    src={`${selectedPoi.document}#toolbar=0&navpanes=0&view=FitH`}
                                    title="PDF Preview"
                                    width="100%"
                                    height="90%"
                                    style={{ minHeight: '80vh', border: 'none' }}
                                />

                                <Box className='box' mt={6} boxShadow="lg" borderRadius="md" p={5} bg="#FFFFFF">
                                    <Grid templateColumns="1fr 1fr" gap={4} mb={4}>
                                        <Text color="gray.600" className='font-poppins text_sm text_medium'>Declared</Text>
                                        <Text className='font-poppins text_sm text_medium'>{selectedPoi.declared}</Text>

                                        <Text color="gray.600" className='font-poppins text_sm text_medium'>Proof Submitted</Text>
                                        <Text className='font-poppins text_sm text_medium'>{selectedPoi.proofSubmitted}</Text>

                                        <Text color="gray.600" className='font-poppins text_sm text_medium'>Verified Amt</Text>
                                        <Input
                                            size="sm"
                                            type="text"
                                            maxW="120px"
                                            placeholder='₹'
                                            value={selectedPoi?.verifiedAmt ? `₹ ${selectedPoi.verifiedAmt}` : ''}
                                            onChange={(e) => {
                                                if (selectedPoiIndex !== null) {
                                                    const rawValue = e.target.value.replace(/[^0-9]/g, '');
                                                    handleVerifiedAmountChange(selectedPoiIndex, rawValue);
                                                }
                                            }}
                                            isDisabled={selectedPoi?.status !== undefined}
                                        />
                                    </Grid>
                                </Box>
                                <Flex justifyContent="flex-end" gap={2} mt={6} mb={4}>
                                    {selectedPoi?.status ? (
                                        <Text
                                            color={selectedPoi.status === 'accepted' ? '#00B103' : '#FF0000'}
                                            className="font-poppins text_sm text_regular"
                                        >
                                            {selectedPoi.status === 'accepted'
                                                ? `Accepted by ${selectedPoi.handledBy}`
                                                : `Rejected by ${selectedPoi.handledBy}`}
                                        </Text>
                                    ) : (
                                        <>
                                            <Button color='#FF0000' bg="#FF00001A" className='font-poppins text_sm text_medium' onClick={() => selectedPoiIndex !== null && openAlert(selectedPoiIndex, 'Reject')}>Reject</Button>
                                            <Button color='white' bg="#00B103" className='font-poppins text_sm text_medium' onClick={() => selectedPoiIndex !== null && openAlert(selectedPoiIndex, 'Accept')}>Accept</Button>

                                        </>
                                    )}
                                </Flex>
                            </>
                        ) : (
                            <Text>No document selected.</Text>
                        )}
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
            <AlertCard
                isOpen={alertOpen}
                onClose={() => setAlertOpen(false)}
                onConfirm={onConfirmStatusChange}
                title={alertStatus === 'Accept' ? 'Approve Document' : 'Reject Document'}
                description={`Are you sure you want to ${alertStatus?.toLowerCase()} this POI?`}
                confirmLabel="Confirm"
                colorScheme={alertStatus === 'Accept' ? 'green' : 'red'}
            />

        </MyDiv>
    );
};

export default NewProofTaxRegime;
